export enum EStoreRedirectEventType {
    STARTED = 'started',
    TOKEN_CREATED = 'token-created',
    NAVIGATION_DISPATCHED = 'navigation-dispatched',
    FAILED = 'failed',
}

export interface IStoreRedirectEventData {
    destinationHost: string;
    durationMilliseconds?: number;
    journeyId: string;
    reasonCode?: string;
}

export type StoreRedirectEvent = [
    EStoreRedirectEventType,
    IStoreRedirectEventData,
];

export interface IStoreRedirectDeps {
    createJourneyId?: () => string;
    getRedirectToken: () => Promise<string>;
    isLoggedIn: boolean;
    now?: () => number;
    onRedirectEvent?: (event: StoreRedirectEvent) => void;
    setAutoCollectFlag: () => void;
}

export interface IStoreRedirectOptions {
    autoCollectOfferId?: string;
}

export interface IStoreRedirect {
    redirect: (
        redirectUrl?: string,
        isStoreRedirect?: boolean,
        options?: IStoreRedirectOptions,
    ) => Promise<void>;
}
